const uiConfig = require("../../uiConfig");
const { getMessageForFetchError } = require("../utils/apiError");
const { apiFetch } = require("./apiFetch");

async function inviteUser({ account_id, _id }) {
  const serverUrl = uiConfig.serverInfo.serverUrl;
  try {
    const resp = await apiFetch(serverUrl + "/inviteUser", {
      method: "POST",
      body: JSON.stringify({ account_id, _id }),
    });
    const data = await resp.json().catch(() => ({}));
    if (!resp.ok) {
      const msg = (data && (data.message || data.error)) || "Failed to send invite.";
      throw new Error(msg);
    }
    return data || {};
  } catch (err) {
    const msg = getMessageForFetchError(err);
    throw new Error(msg);
  }
}

module.exports = { inviteUser };
